export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_10.d22c4d89.jpg";